package org.example.project.service

import kotlinx.serialization.encodeToString
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

object ScreenEnvironmentApi {
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun all(): List<All> {
        val raw = runCatching { LumaticaApiManager.call("screenumgebung/all") }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching { json.decodeFromString<List<All>>(raw) }.getOrDefault(emptyList())
    }

    suspend fun save(config: List<All>): List<All> {
        val raw = LumaticaApiManager.postJson("screenumgebung/save", json.encodeToString(config))
        return runCatching { json.decodeFromString<List<All>>(raw) }.getOrDefault(config)
    }

    suspend fun environment(): String = runCatching {
        val raw = LumaticaApiManager.call("screenumgebung/environment")
        json.parseToJsonElement(raw).jsonObject["environment"]?.jsonPrimitive?.content.orEmpty()
    }.getOrDefault("")
}
